import injectionHelpers from '@carwow/injection-rules-helpers';

const shouldInjectSubscriptionAndNewsletter = ({ options, viewport }) => {
  const {
    currentRuleComponentTypeWordCount: wordCount,
    currentRuleInjectedComponentCount,
    currentType,
    nextType,
    props: {
      adSettings: {
        beforeInlineSubsDesktopAds,
        beforeInlineNewsletterDesktopAds,
        beforeInlineSubsMobileAds,
        beforeInlineNewsletterMobileAds,
      },
    },
  } = options;

  let isNewsletterAndSubscrConfigSame;
  let newsletterAndSubscrConfigSameValue;

  if (viewport === 'mobile') {
    isNewsletterAndSubscrConfigSame = beforeInlineSubsMobileAds === beforeInlineNewsletterMobileAds;
    newsletterAndSubscrConfigSameValue = beforeInlineSubsMobileAds;
  } else if (viewport === 'desktop') {
    isNewsletterAndSubscrConfigSame = beforeInlineSubsDesktopAds === beforeInlineNewsletterDesktopAds;
    newsletterAndSubscrConfigSameValue = beforeInlineSubsDesktopAds;
  }

  if (!isNewsletterAndSubscrConfigSame
    || (isNewsletterAndSubscrConfigSame && newsletterAndSubscrConfigSameValue === 0)) return false;
  if (injectionHelpers.hasRuleBeenInjected(currentRuleInjectedComponentCount)) return false;
  if (injectionHelpers.isBetweenTwoTextBlocks({ currentType, nextType }) === false) return false;

  return wordCount >= beforeInlineNewsletterMobileAds;
};

export default shouldInjectSubscriptionAndNewsletter;
